var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 17,
  fill: "none",
  viewBox: "0 0 27 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.938 7.313H.375v2.916h20.563l-4.521 4.521 2.041 2.042L26.48 8.77 18.604.75l-2.041 2.042z"
})));
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjkzNzUgNy4zMTI1SDAuMzc1VjEwLjIyOTJIMjAuOTM3NUwxNi40MTY3IDE0Ljc1TDE4LjQ1ODMgMTYuNzkxN0wyNi40NzkyIDguNzcwODNMMTguNjA0MiAwLjc1TDE2LjU2MjUgMi43OTE2N0wyMC45Mzc1IDcuMzEyNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";